import React, { FC, useState } from 'react'
import moment, { Moment } from 'moment'
import DownArrowIcon from 'transfix-icons/build/DownArrowIcon'
import { Button } from 'transfix-ui/components/Button'
import { Popover, makeStyles } from 'transfix-ui/core'
import { DatePicker, MaterialUiPickersDate } from 'transfix-ui/core/pickers'
import { brandColors } from 'transfix-ui/theme/colors'

const useDatePickerMobileStyles = makeStyles(theme => ({
  button: {
    color: brandColors.black,
    marginRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
  },
  datePickerLabel: {
    color: brandColors.black,
  },
}))

interface IDatePickerMobileProps {
  onChange: (value: MaterialUiPickersDate) => void
  value: Moment | null
}

export const DatePickerMobile: FC<IDatePickerMobileProps> = ({ onChange: onDateChange, value }) => {
  const classes = useDatePickerMobileStyles()
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const onDatePickerChange = (value: MaterialUiPickersDate) => {
    handlePopoverClose()
    onDateChange(value)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'date-picker-mobile-popover' : undefined
  const buttonLabel = moment(value).format('MMM YYYY')

  return (
    <div>
      <Button
        className={classes.button}
        endIcon={<DownArrowIcon color='skyBlue6' />}
        color='tertiary'
        data-test='fleet-view-date-picker-trigger'
        onClick={handleButtonClick}>
        <span className={classes.datePickerLabel}>{buttonLabel}</span>
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}>
        <DatePicker orientation='landscape' value={value} onChange={onDatePickerChange} />
      </Popover>
    </div>
  )
}

export default DatePickerMobile
